import styles from "./styles.module.css";

export default PageContact;

function PageContact() {
   return <div>
      <div className={styles.header}>
         Contact
      </div>
      <div className={styles.body}>
         erikandresen10@gmail.com
      </div>
   </div>;
}
